// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bab10b13","148":"d5124317","456":"b87023fa","535":"5f68acf0","637":"07615cb0","717":"11e7837e"}[chunkId] + ".chunk.js";
};